module.exports = function getResource(label, vars = []) {
    let resources = {
        emailAndMailPreferences: 'Email & Mail Preferences'
    };
    return resources[label];
};
